<template>
  <div class="spinner-loader-container">
    <div class="loading-spinner">
      <div class="kt-spinner kt-spinner--md kt-spinner--info"></div>
    </div>
    <p v-if="withMessage">{{ message || "Loading..." }}</p>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    withMessage: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Loading...",
    },
  },
};
</script>

<style lang="scss" scoped>

.spinner-loader-container {
  padding: 1rem;
  
}

.product-display .spinner-loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.page-designs .product-display .spinner-loader-container {
  height: 100%;
}

.loading-spinner {
  margin: auto;
  .kt-spinner {
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      left: initial !important;
      margin-top: -10px !important;
    }
  }
}
p {
  margin: auto;
  margin-top: 1rem;
  text-align: center;
}

#showroom-banner {
  .decoration-preview {
    .spinner-loader-container {
      padding: 0 !important;
      .loading-spinner {
        width: 100%;
        height: 100%;
        padding: 1px 0 0 10px;
        margin: -5px 0px;
      }
    }
  }
}
</style>
